module.exports = __webpack_public_path__ + "img/test-completed.2787c669.png";